webpackJsonp([11,47],{

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_3_vue___default.a.filter('formatDateTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('MMMM DD, YYYY');
  }
});
/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ShareButton: __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue___default.a
  },
  props: ['dialog', 'item'],
  data: function data() {
    return {
      openModal: false,
      favorited: false
    };
  },
  watch: {
    openModal: function openModal(val) {}
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    favoriteItem: function favoriteItem() {
      var favoritePayload = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, this.item.id, this.item.id);

      this.$firebase.database().ref("favorites/resources/".concat(this.user.uid, "/").concat(this.item.id)).set(favoritePayload);
    },
    unfavoriteItem: function unfavoriteItem() {
      console.log('clicked');
      this.$firebase.database().ref("favorites/resources/".concat(this.user.uid, "/").concat(this.item.id)).set(null);
    },
    isFavourited: function isFavourited() {
      var self = this;
      this.$firebase.database().ref("favorites/resources/".concat(this.user.uid, "/").concat(this.item.id)).on('value', function (snapshot) {
        if (!snapshot.val()) {
          self.favorited = false;
        } else {
          self.favorited = true;
        }
      });
    }
  },
  computed: {
    breakpoint: function breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    htmlContent: function htmlContent() {
      return this.item.content;
    },
    openDialog: function openDialog() {
      this.openModal = this.dialog;

      if (this.openModal === true) {
        this.isFavourited();
      }

      return this.dialog;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    userDetails: function userDetails() {
      return this.$store.getters.getUserDetails;
    },
    shareLink: function shareLink() {
      return window.location;
    },
    link: function link() {
      return "https://".concat(window.location.host, "/resources#id=").concat(this.item.id);
    }
  }
};

/***/ }),

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".group[data-v-04e686ba]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-pack:distribute;justify-content:space-around}.tabs__wrapper[data-v-04e686ba]{overflow:hidden}.vue-highcharts[data-v-04e686ba]{border:none;-webkit-box-shadow:none;box-shadow:none}.tabs__content[data-v-04e686ba]{height:500px;overflow-x:hidden;overflow-y:scroll}.resource_post_details[data-v-04e686ba]{padding-top:220px}.resource_post_details span[data-v-04e686ba],.resource_post_details strong[data-v-04e686ba]{color:#fff;font-size:16px}.resource_content h2[data-v-04e686ba]{font-size:28px;color:#000;line-height:32px;font-weight:600}.resource_content p[data-v-04e686ba]{margin-bottom:0;font-size:18px;color:#666}.post_img[data-v-04e686ba]{height:300px;line-height:300px;width:100%;text-align:center}.post_img img[data-v-04e686ba]{max-height:300px;width:auto;display:inline-block;vertical-align:middle;line-height:normal}.post_img iframe[data-v-04e686ba]{min-height:300px;width:100%;border:none}", "", {"version":3,"sources":["/home/circleci/repo/src/components/modal/info/resourceViewModal.vue"],"names":[],"mappings":"AACA,wBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AACpB,WAAY,AACZ,OAAQ,AACR,yBAA0B,AAC1B,4BAA8B,CAC/B,AACD,gCACE,eAAiB,CAClB,AACD,iCACE,YAAa,AACb,wBAAwB,AAChB,eAAgB,CACzB,AACD,gCACE,aAAc,AACd,kBAAkB,AAClB,iBAAmB,CACpB,AACD,wCACI,iBAAkB,CACrB,AACD,4FAGI,WAAW,AACX,cAAgB,CACnB,AACD,sCACI,eAAgB,AAChB,WAAY,AACZ,iBAAkB,AAClB,eAAiB,CACpB,AACD,qCACI,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACf,AACD,2BACI,aAAc,AACd,kBAAmB,AACnB,WAAY,AACZ,iBAAmB,CACtB,AACD,+BACM,iBAAkB,AAClB,WAAY,AACd,qBAAsB,AACtB,sBAAuB,AACvB,kBAAoB,CACvB,AACD,kCACI,iBAAkB,AAClB,WAAY,AACZ,WAAa,CAChB","file":"resourceViewModal.vue","sourcesContent":["\n.group[data-v-04e686ba] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n.tabs__wrapper[data-v-04e686ba] {\n  overflow: hidden;\n}\n.vue-highcharts[data-v-04e686ba] {\n  border: none;\n  -webkit-box-shadow:none;\n          box-shadow:none;\n}\n.tabs__content[data-v-04e686ba] {\n  height: 500px;\n  overflow-x:hidden;\n  overflow-y: scroll;\n}\n.resource_post_details[data-v-04e686ba]{\n    padding-top:220px;\n}\n.resource_post_details strong[data-v-04e686ba],\n  .resource_post_details span[data-v-04e686ba]\n  {\n    color:#fff;\n    font-size: 16px;\n}\n.resource_content h2[data-v-04e686ba]{\n    font-size: 28px;\n    color: #000;\n    line-height: 32px;\n    font-weight: 600;\n}\n.resource_content p[data-v-04e686ba]{\n    margin-bottom: 0;\n    font-size: 18px;\n    color: #666;\n}\n.post_img[data-v-04e686ba]{\n    height: 300px;\n    line-height: 300px;\n    width: 100%;\n    text-align: center;\n}\n.post_img img[data-v-04e686ba]{\n      max-height: 300px;\n      width: auto;\n    display: inline-block;\n    vertical-align: middle;\n    line-height: normal;\n}\n.post_img iframe[data-v-04e686ba]{\n    min-height: 300px;\n    width: 100%;\n    border: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1171:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("416e0fbe", content, true, {});

/***/ }),

/***/ 1198:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1127),
  /* template */
  __webpack_require__(1215),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04e686ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1215:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "800px",
      "persistent": "",
      "transition": "scale-transition",
      "max-height": "600px"
    },
    model: {
      value: (_vm.openDialog),
      callback: function($$v) {
        _vm.openDialog = $$v
      },
      expression: "openDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "overflow": "hidden",
      "display": "block"
    }
  }, [(_vm.item) ? _c('v-layout', {
    attrs: {
      "id": "resource-modal"
    }
  }, [_c('v-flex', {
    staticClass: "resource-main",
    staticStyle: {
      "height": "600px",
      "overflow-y": "scroll"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    staticClass: "secondary",
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "resource_content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "resource-details-actions secondary"
  }, [_c('h2', {
    staticClass: "py-4 px-4 resource-title text-sm-center white--text"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-4": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "pt-1": "",
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("access_time")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("actualDate")(_vm.item.submitdate)))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "white--text",
    attrs: {
      "pt-1": "",
      "sm4": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("list_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.category))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "white--text",
    attrs: {
      "pt-1": "",
      "sm4": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "color": "white"
    }
  }, [_vm._v("fa-tags")]), _vm._v(" "), _vm._l((_vm.item.tags), function(tag, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(tag)), (index + 1 < _vm.item.tags.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pt-2 post_img resource-media"
  }, [(_vm.item.media.id) ? _c('iframe', {
    attrs: {
      "src": _vm.item.media.embedUrl,
      "allowfullscreen": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.item.media,
      "alt": "Agency Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "px-4 py-4 description resource-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-card-actions', {
    staticStyle: {
      "position": "relative",
      "bottom": "25px",
      "width": "100%"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-1 pt-1 mx-4 text-xs-center",
    attrs: {
      "justify-space-around": ""
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "activator",
      "small": "",
      "secondary--text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-layout', {
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "secondary--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("favorite")])], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "activator",
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-layout', {
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "color": "red"
    }
  }, [_vm._v("favorite")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "link": _vm.link
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_info_resourceViewModal_vue__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_info_resourceViewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modal_info_resourceViewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminSideBar_vue__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdminSideBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Components_AdminSideBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_PageFooter_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_PageFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Components_PageFooter_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AdminSideBarMenu: __WEBPACK_IMPORTED_MODULE_2__Components_AdminSideBar_vue___default.a,
    PageFooter: __WEBPACK_IMPORTED_MODULE_3__Components_PageFooter_vue___default.a,
    ResourcesModal: __WEBPACK_IMPORTED_MODULE_1__components_modal_info_resourceViewModal_vue___default.a
  },
  mounted: function mounted() {
    this.$store.dispatch('fetchResources');
    var payload = {
      meta: {
        h1: "Admin Resources",
        title: "Resources",
        description: "Admin Settings",
        keywords: "",
        requiresAuth: true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit("setHeaderInfo", payload);
  },
  computed: {
    resources: function resources() {
      return this.$store.getters.getResources;
    },
    process: function process() {
      return this.$store.getters.getProcess;
    },
    allResources: function allResources() {
      var _this = this;

      return this.resources.filter(function (company) {
        return company.verified === _this.currentStatus;
      }).sort(function (d1, d2) {
        return new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime();
      });
    }
  },
  data: function data() {
    return {
      search: '',
      e1: '',
      ex11: true,
      pagination: {},
      selectedItem: null,
      cmp1: [],
      pickedItem: {},
      dialog: false,
      currentStatus: 'all',
      currentEventId: '',
      dateRange: 0,
      view_dialog: false,
      emailDialog: false,
      info: [{
        name: 'Company Info',
        tabId: 'company_info'
      }, {
        name: 'Contracting Info',
        tabId: 'contracting_info'
      }, {
        name: 'Other Info',
        tabId: 'other_info'
      }],
      headers: [{
        text: 'Submit date',
        align: 'left',
        sortable: false,
        value: 'submitdate'
      }, {
        text: 'Revision Date',
        align: 'left',
        sortable: false,
        value: 'revisiondate'
      }, {
        text: 'Submitted by',
        value: 'user',
        align: 'left',
        sortable: false
      }, {
        text: 'Title',
        value: 'title',
        align: 'left',
        sortable: false
      }, {
        text: 'Category',
        align: 'left',
        sortable: false,
        value: 'category'
      }, {
        text: 'Status',
        value: 'verified',
        align: 'left',
        sortable: false
      }, {
        text: 'Actions',
        value: 'Actions',
        align: 'left',
        sortable: false
      }],
      items: [],
      currentResourceId: null
    };
  },
  methods: {
    cancelViewModal: function cancelViewModal() {
      this.view_dialog = false;
    },
    openViewModal: function openViewModal(item) {
      this.view_dialog = true;
      this.selectedItem = item;
    },
    approveSubmission: function approveSubmission(id, uid) {
      this.$store.dispatch('toggleResourceSubmission', {
        id: id,
        uid: uid,
        value: true
      });
    },
    rejectSubmission: function rejectSubmission(id, uid) {
      this.$store.dispatch('toggleResourceSubmission', {
        id: id,
        uid: uid,
        value: false
      });
    },
    filterStatus: function filterStatus(status) {
      this.currentStatus = status;
    },
    deleteRow: function deleteRow() {
      var payload = {
        type: 'resources',
        postId: this.currentResourceId
      };
      this.$store.dispatch('deletePost', payload);
      this.dialog = false;
    },
    sendMail: function sendMail() {
      this.$store.dispatch('sendEmailToAllUsers', {
        type: 'new_resource'
      });
    },
    assignId: function assignId(postId, type) {
      this.currentResourceId = postId;
      this.pickedItem = this.resources.find(function (item) {
        return item.id === postId;
      });
      this[type] = true;
    },
    goto: function goto(link) {
      this.$router.push(link);
    }
  }
};

/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "#right{float:right!important}#toggle_status{margin-top:10px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/ResourcesListView.vue"],"names":[],"mappings":"AACA,OACE,qBAAwB,CACzB,AACD,eACE,eAAiB,CAClB","file":"ResourcesListView.vue","sourcesContent":["\n#right {\n  float: right !important;\n}\n#toggle_status {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1506:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1417);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("493e585f", content, true, {});

/***/ }),

/***/ 1716:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Resources")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "bordered-card",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n            Resources\n          ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goto('/admin/resources/new')
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n              Add new\n            ")], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.resources,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "content-table-row"
        }, [_c('td', [_vm._v(_vm._s(_vm._f("actualDate")(props.item.submitdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("actualDate")(props.item.revisiondate)))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v("\n                " + _vm._s(props.item.user.firstname) + " " + _vm._s(props.item.user.lastname) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(props.item.category))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(props.item.featured === true ? 'Featured' : 'Not Featured'))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [(props.item.featured === false) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.approveSubmission(props.item.id, props.item.submitby)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Feature")])], 1) : _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.rejectSubmission(props.item.id, props.item.submitby)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove Featured")])], 1), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.goto('/admin/resources/new?mode=edit&id=' + props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "medium": ""
          },
          on: {
            "click": function($event) {
              return _vm.assignId(props.item.id, 'emailDialog')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("email")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.openViewModal(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.assignId(props.item.id, 'dialog')
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1)], 1)])]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n          ")]
      }
    }])
  })], 1), _vm._v(" "), _c('PageFooter')], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.emailDialog),
      callback: function($$v) {
        _vm.emailDialog = $$v
      },
      expression: "emailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confim Email")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to notify all users?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false;
        _vm.sendMail()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Really delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteRow()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('resources-modal', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "dialog": _vm.view_dialog,
      "item": _vm.selectedItem
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelViewModal()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1506)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1301),
  /* template */
  __webpack_require__(1716),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-060504ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      items: [{
        icon: '',
        text: 'Home',
        link: '/admin/settings/home'
      }, {
        icon: '',
        text: 'Settings',
        link: '/admin/settings/pages',
        children: [{
          icon: '',
          text: 'General Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'general-settings'
          }
        }, {
          icon: '',
          text: 'Email Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'email-settings'
          }
        }, {
          icon: '',
          text: 'Directory',
          link: '/admin/settings/pages',
          query: {
            page: 'directory'
          }
        }, {
          icon: '',
          text: 'Resources',
          link: '/admin/settings/pages',
          query: {
            page: 'resources'
          }
        }, {
          icon: '',
          text: 'Opportunities',
          link: '/admin/settings/pages',
          query: {
            page: 'opportunities'
          }
        }, {
          icon: '',
          text: 'History',
          link: '/admin/settings/pages',
          query: {
            page: 'history'
          }
        }, {
          icon: '',
          text: 'DoD Contract Analytics',
          link: '/admin/settings/pages',
          query: {
            page: 'dod-contract-analytics'
          }
        }, {
          icon: '',
          text: 'Bid Alerts',
          link: '/admin/settings/pages',
          query: {
            page: 'bid_alerts'
          }
        }, {
          icon: '',
          text: 'Questionnaire',
          link: '/admin/settings/pages',
          query: {
            page: 'questionnaire'
          }
        }, {
          icon: '',
          text: 'Favorites',
          link: '/admin/settings/pages',
          query: {
            page: 'favorites'
          }
        }, {
          icon: '',
          text: 'Tracking',
          link: '/admin/settings/pages',
          query: {
            page: 'tracking'
          }
        }]
      }, {
        icon: '',
        text: 'Users',
        link: '/admin/settings/users',
        children: [{
          icon: '',
          text: 'Manage Users',
          link: '/admin/settings/users',
          query: {
            page: 'manage-users'
          }
        }, {
          icon: '',
          text: 'Usage Tracking',
          link: '/admin/settings/users',
          query: {
            page: 'usage-tracking'
          }
        }, {
          icon: '',
          text: 'Default Chat Contact',
          link: '/admin/settings/users',
          query: {
            page: 'default-chat-contact'
          }
        }]
      }, {
        icon: '',
        text: 'Access',
        link: '/admin/settings/priviledges'
      }, {
        icon: '',
        text: 'Resources',
        link: '/admin/resources/all'
      }, {
        icon: '',
        text: 'Companies',
        link: '/admin/companies',
        children: [{
          icon: '',
          text: 'Update Company',
          link: '/admin/companies/update-company'
        }, {
          icon: '',
          text: 'Add Company',
          link: '/admin/companies/add-company'
        }]
      }, {
        icon: '',
        text: 'Requests',
        link: '/admin/settings/requests',
        children: [{
          icon: '',
          text: 'Activity Stream',
          link: '/admin/settings/requests',
          query: {
            page: 'activity'
          }
        }, {
          icon: '',
          text: 'Events',
          link: '/admin/settings/requests',
          query: {
            page: 'events'
          }
        }, {
          icon: '',
          text: 'Company Submission',
          link: '/admin/settings/requests',
          query: {
            page: 'companies'
          }
        } // {
        //   icon: '',
        //   text: 'Group Post',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'groups'
        //   }
        // },
        // {
        //   icon: '',
        //   text: 'Group Events',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'group-events'
        //   }
        // }
        ]
      }, {
        icon: '',
        text: 'Feedback/Support',
        link: '/admin/settings/support',
        children: [{
          text: 'Feedback',
          link: '/admin/settings/support',
          query: {
            page: 'feedback'
          }
        }, {
          text: 'Help Requests',
          link: '/admin/settings/support',
          query: {
            page: 'help-requests'
          }
        }]
      }, {
        icon: '',
        text: 'Admin Tutorials',
        link: '/admin/settings/tutorials',
        children: [{
          text: 'All Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'all'
          }
        }, {
          text: 'Manage Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'manage'
          }
        }]
      }]
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  methods: {
    checkUserRole: function checkUserRole() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var usr, fb, user, alert;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                usr = _this.$store.getters.getUserDetails;
                fb = _this.$firebase.database().ref();
                _context.next = 4;
                return fb.child('users/' + usr.uid.toString()).once('value');

              case 4:
                user = _context.sent;

                if (user.role !== 1) {
                  alert = {
                    ative: true,
                    header: 'Access denied',
                    text: "You don't have access on this page",
                    okText: 'Ok',
                    cancelText: ''
                  };

                  _this.$store.dispatch('triggerAlert', alert);

                  _this.$router.push('/user/feed');
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isOpen: function isOpen(rootPath) {
      return this.$route.fullPath.indexOf(rootPath) > -1;
    }
  }
};

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebar-menu[data-v-060504ef]{top:55px}.list__tile--active[data-v-060504ef],.list__tile--active[data-v-060504ef]:hover{background-color:rgba(0,0,0,.1)!important}.menu_list_data[data-v-060504ef]{width:100%}.menu_list_data li[data-v-060504ef]{margin-bottom:12px;padding-right:20px}.menu_list_item_data[data-v-060504ef]{font-size:16px}.list__group i[data-v-060504ef],.list__tile i[data-v-060504ef]{color:#a2a2a2}.list__tile__action[data-v-060504ef]{min-width:30px}.list__group__header--active[data-v-060504ef],.list__group__items[data-v-060504ef]{background-color:rgba(0,0,0,.4)}.list[data-v-060504ef]{background:transparent!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/AdminSideBar.vue"],"names":[],"mappings":"AACA,+BACE,QAAU,CACX,AAID,gFACE,yCAAgD,CACjD,AACD,iCACE,UAAY,CACb,AACD,oCACE,mBAAoB,AACpB,kBAAoB,CACrB,AACD,sCACE,cAAgB,CACjB,AACD,+DACE,aAAe,CAChB,AACD,qCACE,cAAgB,CACjB,AAID,mFACE,+BAAqC,CACtC,AACD,uBACE,gCAAmC,CACpC","file":"AdminSideBar.vue","sourcesContent":["\n.sidebar-menu[data-v-060504ef] {\n  top: 55px;\n}\n.list__tile--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.list__tile--active[data-v-060504ef]:hover {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.menu_list_data[data-v-060504ef] {\n  width: 100%;\n}\n.menu_list_data li[data-v-060504ef] {\n  margin-bottom: 12px;\n  padding-right: 20px;\n}\n.menu_list_item_data[data-v-060504ef] {\n  font-size: 16px;\n}\n.list__group i[data-v-060504ef], .list__tile i[data-v-060504ef] {\n  color: #a2a2a2;\n}\n.list__tile__action[data-v-060504ef] {\n  min-width: 30px;\n}\n.list__group__items[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list__group__header--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list[data-v-060504ef] {\n  background: transparent !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(843);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("91f344b8", content, true, {});

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "sidebar-menu",
    style: ({
      backgroundColor: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "dark": "",
      "fixed": "",
      "value": true,
      "mobile-break-point": 768,
      "clipped": true
    }
  }, [_c('v-list', {
    staticClass: "menu_list_data",
    attrs: {
      "dark": ""
    }
  }, _vm._l((_vm.items), function(item, i) {
    return (item.children) ? _c('v-list-group', {
      key: i,
      attrs: {
        "value": _vm.isOpen(item.link)
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "color": "grey"
      },
      slot: "activator"
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(sub_item, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "router": "",
          "to": sub_item.query ? ((sub_item.link) + "/" + (sub_item.query.page)) : ("" + (sub_item.link))
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        staticClass: "menu_list_item_data",
        attrs: {
          "color": "white"
        }
      }, [_vm._v(_vm._s(sub_item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "white--text menu_list_item_data"
      }, [_vm._v("\n            " + _vm._s(sub_item.text) + "\n          ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "router": "",
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".page-footer[data-v-1c309d0c]{position:absolute;height:50px;right:0;bottom:0;left:300px;background:#f9f9fa;border-top:1px solid #e1e6ef;text-align:center;line-height:50px;color:#151b1e}.page-footer p[data-v-1c309d0c]{margin:0}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/PageFooter.vue"],"names":[],"mappings":"AACA,8BACE,kBAAmB,AACnB,YAAa,AACb,QAAS,AACT,SAAU,AACV,WAAY,AACZ,mBAAoB,AACpB,6BAA8B,AAC9B,kBAAmB,AACnB,iBAAkB,AAClB,aAAe,CAChB,AACD,gCACI,QAAU,CACb","file":"PageFooter.vue","sourcesContent":["\n.page-footer[data-v-1c309d0c] {\n  position: absolute;\n  height: 50px;\n  right: 0;\n  bottom: 0;\n  left: 300px;\n  background: #f9f9fa;\n  border-top: 1px solid #e1e6ef;\n  text-align: center;\n  line-height: 50px;\n  color: #151b1e;\n}\n.page-footer p[data-v-1c309d0c] {\n    margin: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(871);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("2eac6325", content, true, {});

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var Component = __webpack_require__(14)(
  /* script */
  null,
  /* template */
  __webpack_require__(877),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c309d0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 877:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer mt-4"
  }, [_c('p', [_vm._v("Georgia Defense-Exchange")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.78806944552bfe896d58.js